import { CompletedCollectible } from "@/types/highlights"
import { erc721ABI } from "@/util/typechain-v0"
import { BigNumber } from "ethers"
import { parseEther } from "ethers/lib/utils"
import { getChainId } from "@/util/crypto"

import {
  useAccount,
  useContractRead,
  useContractWrite,
  usePrepareContractWrite,
} from "wagmi"

function useGetPrice(props: {
  contractAddress: string
  chainId: number
  enabled: boolean
}) {
  const { data, error, isError, isLoading } = useContractRead({
    address: props.contractAddress as "0x${string}",
    abi: erc721ABI,
    chainId: props.chainId,
    functionName: "priceWei",
    enabled: props.enabled,
  })

  console.log("Got price data", data, error, isError, isLoading)

  return { data, error, isError, isLoading }
}

export default function useMintExistingCollectibleV1(
  collectible: CompletedCollectible
) {
  const enabled = collectible.version === 0

  const chainId = getChainId(collectible.chain)
  const accountData = useAccount()
  const { data: priceWei, error: priceError } = useGetPrice({
    contractAddress: collectible.contractAddress,
    chainId,
    enabled,
  })

  const { config, error: prepareError } = usePrepareContractWrite({
    address: collectible.contractAddress as "0x${string}",
    abi: erc721ABI,
    functionName: "mint",
    chainId,
    args: [accountData.address as `0x${string}`],

    overrides: {
      value:
        (priceWei as BigNumber | undefined) ||
        parseEther(collectible.costEth.toString()),
    }, // Need to pass this in as eth
    enabled,
  })

  const writeData = useContractWrite(config)

  return { ...writeData, prepareError, priceError, priceWei }
}
